import { SourceList } from '@/pages/sources/SourceList'
import { createFileRoute } from '@tanstack/react-router'
import { useDocumentTitle } from "usehooks-ts"
import { APP_NAME } from '@/lib/env';
export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/sources/')({
  component: SourcesPage,
})

function SourcesPage() {
  useDocumentTitle(`Sources - ${APP_NAME}`) 
  return <SourceList />
} 